import React, { useEffect, useState } from "react";
import { FiLogOut } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Text,
  Content,
  RightContent,
  LeftContent,
  Menu,
  MenuItem,
} from "./style";
import { Button } from "antd";
import logo from "../../../assets/logo.png";
import { clearToken } from "../../../redux/modules/auth/actions";

import { useNavigate } from "react-router-dom";
import { clearSelectedDate } from "../../../redux/modules/dates/actions";
import Logo from "../../../components/Logo";

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isActive, setIsActive] = useState(1);
  const navigate = useNavigate();

  const data = [
    { key: 1, title: "Бўлимлар", href: "/" },
    { key: 2, title: "Категория", href: "/category" },
    { key: 3, title: "Обектлар", href: "/object" },
    { key: 4, title: "Фойдаланувчилар", href: "/users" },
    { key: 5, title: "Созламалар", href: "/setting" },
    { key: 6, title: "Хабарлар", href: "/messages" },
    // { key: 6, title: "Статистика", href: "/statistica" },
  ];

  const handlePage = (key, href) => {
    setIsActive(key);
    navigate(href);
  };

  useEffect(() => {
    setIsActive(data?.find((item) => item.href === location.pathname)?.key);
  }, [location]);

  const handleLogOut = () => {
    dispatch(clearToken());
    dispatch(clearSelectedDate());
  };

  return (
    <Content>
      <LeftContent>
        <Logo />
        {/* <Text>АДМИН ПАНЕЛ</Text> */}
        <Menu>
          {data.map((item, index) => (
            <MenuItem
              key={index + 1}
              isActive={isActive === item.key}
              onClick={() => {
                handlePage(item.key, item.href);
              }}
            >
              {item.title}
            </MenuItem>
          ))}
        </Menu>
      </LeftContent>
      <RightContent>
        {" "}
        <Button
          onClick={() => handleLogOut()}
          style={{ background: "none", border: "none" }}
          shape="circle"
          icon={<FiLogOut color="#00b5e4" size="25" />}
        />
      </RightContent>
    </Content>
  );
};
